import './utils/invitationContext';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { initSentry } from './sentry';
// i18n must initialize before App mounts so useTranslation() has resources.
// Import is for side effects only — react-i18next reads the singleton.
import './i18n';
import App from './App';
import './index.css';

// Initialize error tracking before anything renders so early errors are caught.
initSentry();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
